import { render, staticRenderFns } from "./Etiquetas.vue?vue&type=template&id=62f5dc81&scoped=true"
import script from "./Etiquetas.vue?vue&type=script&lang=js"
export * from "./Etiquetas.vue?vue&type=script&lang=js"
import style0 from "./Etiquetas.vue?vue&type=style&index=0&id=62f5dc81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5dc81",
  null
  
)

export default component.exports